import axios from "axios";
import { server } from "../../lib/server";

export default axios.create({
  baseURL: `${server}`,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});
